export const greetings = {
    ['00:00:00-11:59:59']: 'time_slot_to_string.{language_key}_good_morning',
    ['12:00:00-18:59:59']: 'time_slot_to_string.{language_key}_good_afternoon',
    ['19:00:00-23:59:59']: 'time_slot_to_string.{language_key}_good_evening',
} as const;